/* [PATCH aplikacije-fe v1] /izbira-podjetja — po izbiri aplikacije, če ima uporabnik več podjetij. Isti seznam kot v okvirju. */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { useAuthStore } from '../stores/authStore';
import { useAplikacija } from '../hooks/useAplikacija';
import { ciljAplikacije } from '../aplikacije';
import { VstopnaLupina } from '../components/VstopnaLupina';
import { IzbiraPodjetja } from '../components/IzbiraPodjetja';

export function IzbiraPodjetjaPage() {
  const navigate = useNavigate();
  const { setSelectedCompany } = useAuthStore();
  const { aplikacija, opis } = useAplikacija();
  const [companies, setCompanies] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [smeOdpirati, setSmeOdpirati] = useState(false);

  useEffect(() => { if (!aplikacija) navigate('/', { replace: true }); }, [aplikacija, navigate]);
  useEffect(() => {
    api.get('/companies/').then((r: any) => setCompanies(r.data)).catch(() => {}).finally(() => setLoading(false));
    api.get('/auth/me').then((r: any) => setSmeOdpirati(!!(r.data.is_superadmin || r.data.can_create_companies))).catch(() => setSmeOdpirati(false));
  }, []);

  const izberi = (c: any) => { setSelectedCompany(c); navigate(ciljAplikacije(aplikacija)); };

  return (
    <VstopnaLupina naslov={opis ? opis.naziv : 'Izbira podjetja'} podnaslov="Izberite podjetje, s katerim želite delati" nazaj={{ label: 'Druga aplikacija', to: '/?izbira=1' }}>
      <IzbiraPodjetja companies={companies} loading={loading} smeOdpirati={smeOdpirati} onIzberi={izberi} naslov="" podnaslov="" />
    </VstopnaLupina>
  );
}
